'use es6';

import { createSelectorCreator, defaultMemoize } from 'reselect';
export const createUnmemoizedSelector = createSelectorCreator({
  memoize: defaultMemoize,
  memoizeOptions: [() => false],
  argsMemoize: fn => fn
});